module.exports = __webpack_public_path__ + "static/media/Gobi-Small-Smile-Blink.69162273.png";